<template>
  <!-- 修改信息对话框 -->
  <el-dialog :custom-class="computedLength.length >= 22 ? 'el-dialogResetHeight' : ''"
             :visible.sync="dialogVisible" :before-close="closeDialog"
             :close-on-click-modal="false">
    <div slot="title" class="el-dialog__title">
      <div class="title-left"></div>
      <slot name="title">{{$t('personCenterV2.editUserInfo')}}</slot>
      <div class="title-right"></div>
    </div>
    <!-- 表单区域 -->
    <el-form :model="ruleForm" :hide-required-asterisk="true" :rules="editUserInfoRules"
             ref="ruleForm" class="demo-ruleForm">
      <el-form-item :label="$t('personCenterV2.name')" prop="nickName">
        <el-input v-model.trim="ruleForm.nickName" autocomplete="off" :maxlength="16"></el-input>
      </el-form-item>
      <el-form-item :label="$t('personCenterV2.language')" prop="userLangList">
        <el-select :multiple-limit="3" v-model="newPeon"
                   :placeholder="$t('personCenterV2.chooseLanguage')" value-key="id" multiple
                   @change="chanageSelect">
          <el-option v-for="item in allList" :key="item.id"
                     :label="$i18n.locale === 'zh' ? item.name : $langCase[item.code]"
                     :value="item"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose()" class="btn_cancle">{{ $t('personCenterV2.cancle') }}
      </el-button>
      <el-button type="primary" v-preventReClick="2000" @click="sureDialog()">
        {{ $t('personCenterV2.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { languageInfo, newLangList } from '@/services/userInfo'

export default {
  name: 'editUserInfo',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    editUserInfoBtn: {
      type: [String],
      default: '取 消',
    },
    userInfo: Object,
    langList: Array,
  },
  data() {
    //   用户名校验
    // var checkNickName = (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error(this.$t('personCenterV2.nameNotEmpty')))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      // 存储表单数据
      ruleForm: {
        nickName: '',
        userLangList: [],
        idList: [],
      },
      //   表单验证
      editUserInfoRules: {
        //   用户名验证
        nickName: [{ required: true, message: this.$t('personCenterV2.nameNotEmpty'), trigger: 'blur' }],
        // 语言
        language: [],
      },
      //全部语言
      allList: [],
      //   删除的语言列表
      deleteLangList: [],
      //   选中的擅长语言列表
      addLangList: [],
      //   保存选中的语言
      arr: [],
      //   对修改后的语言进去去重
      newPeon: [],
      //文字长度
      textLength: '',
    }
  },
  methods: {
    //   获取全部语言信息
    languageInfo() {
      languageInfo().then((res) => {
        this.allList = res.result
        let arr = this.allList
        let arr1 = []
        arr.forEach((item) => {
          this.ruleForm.userLangList.forEach((item1) => {
            if (item.code === item1.langCode) {
              arr1.push(item)
            }
          })
        })
        this.ruleForm.userLangList = arr1
        // 对回显的语言进行去重
        let newObj = {}
        this.newPeon = this.ruleForm.userLangList.reduce((cur, next) => {
          newObj[next.code] ? '' : (newObj[next.code] = true && cur.push(next))
          return cur
        }, []) //设置cur默认类型为数组，并且初始值为空的数组
      })
    },
    // 语言change事件
    chanageSelect(val) {
      this.ruleForm.userLangList = val
    },
    // 关闭对话框,重置表单
    closeDialog() {
      this.$refs.ruleForm.resetFields()
      this.$parent.getolduserInfo()
      this.$emit('closeUserInfo')
    },
    handleClose() {
      this.$refs.ruleForm.clearValidate()
      this.$parent.getolduserInfo()
      this.$emit('closeUserInfo')
    },
    // 确认按钮,保存修改信息
    sureDialog() {
      this.addLangList = []
      this.ruleForm.userLangList.forEach((item) => {
        this.addLangList.push({
          langCode: item.code || item.langCode,
          langName: item.name || item.langName,
        })
      })
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          let { success } = await newLangList({
            nickName: this.ruleForm.nickName,
            addLangList: this.addLangList,
            deleteLangList: this.arr,
          })
          if (success) {
            this.$message.success(this.$t('personCenterV2.updateSuccess'));
            this.$emit('func', this.addLangList);
            this.$emit('update');
            this.$parent.getTeamInfo();
            this.$emit('closeUserInfo');
          }
        } else {
          return
        }
      })
    },
  },
  watch: {
    //   用户昵称回显
    userInfo: function (e) {
      this.ruleForm.nickName = e.nickName
    },
    // 语言
    langList: function (ne) {
      // 初始化渲染全部语言信息，回显数据
      this.ruleForm.userLangList = ne
      this.arr = ne
    },
  },
  // 选中语言的长度
  computed: {
    computedLength: function () {
      return (this.textLength = this.ruleForm.userLangList
        .map((item) => {
          return item.name
        })
        .join(''))
    },
  },
  created() {
    this.languageInfo()
  },
}
</script>
<style lang="less" scoped>
@import "./assets/style.less";
</style>
